import { Component } from '@angular/core';
import { OnInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';

import { formatString } from '../../utils/string-utils';

/**
 * Provides a view of a non-pdf text product.
 */
@Component({
	selector: 'doc-text-view',
	templateUrl: './doc-text-view.component.html',
	styleUrl: './doc-text-view.component.css'
})
export class DocTextViewComponent implements OnInit {

	@Input() product!: any;
	@Input() documentData!: { [key: string]: any };
	@Input() viewerURL: SafeResourceUrl | undefined;

	@ViewChild('textIframe') textIframeRef!: ElementRef<HTMLIFrameElement>;

	LOCALIZATION: any;

	documentAttachments: any[] = [];
	attachmentsTabIndex: number = 0;

	constructor(
		private userService: UserService,
		private configService: ConfigService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	ngOnInit(): void {
		this.loadDocument();
	}
	
	/**
	 * Reinitialize this component without destroying the DOM.
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes['viewerURL'] || changes['product']) {
			this.loadDocument();
		}
	}

	private loadDocument(): void {
		if (this.documentData['attachments'] && this.documentData['attachments'].length > 0) {
			// We can assume its a email subtype (SupportFileType.ATTACHMENT - treated as TXT)
			this.documentAttachments = [];
			for (let i = 0; i < this.documentData['attachments'].length; i++) {
				this.documentAttachments.push({
					url: formatString(this.configService.getConfig().document.documentAttachmentURL, this.product.id, this.documentData['attachments'][i].id),
					name: this.documentData['attachments'][i].name
				});
			}
		}
	}

	text_viewer_onload(event: Event): void {
		console.log("viewer iframe loaded - event triggered");

		if (!this.textIframeRef) {
		  console.error('iframe not ready yet!');
		  return;
		}
		
		this.buildMarkupSearchHitData();
		this.scrollToMarkup();
	}

	private buildMarkupSearchHitData(): void {
		const iframe = this.textIframeRef.nativeElement;
		let markup = iframe.contentDocument?.querySelectorAll('mark');
		if (!markup || markup?.length == 0) { return; }
		this.documentData['searchHitData'].hasHit = true;
		this.documentData['searchHitData'].hitIndex = markup;
		this.documentData['searchHitData'].highlightsTotal = this.documentData['searchHitData'].hitIndex.length;
		this.documentData['searchHitData'].currentHighlight = 0;
	}

	private scrollToMarkup(idx?: number): void {
		if (!idx) idx = 0;
		if (!this.documentData['searchHitData'] || !this.documentData['searchHitData'].highlightsTotal) { return; }
		this.documentData['searchHitData'].hitIndex[idx].scrollIntoView({
			behavior: "smooth",
			block: "start",
			inline: "nearest"
		});
	}
	
	prevHit(): void {
		if (this.hasPrevMarkup() == false) return;
		--this.documentData['searchHitData'].currentHighlight;
		this.scrollToMarkup(this.documentData['searchHitData'].currentHighlight);
	}

	nextHit(): void {
		if (this.hasNextMarkup() == false) return;
		++this.documentData['searchHitData'].currentHighlight;
		this.scrollToMarkup(this.documentData['searchHitData'].currentHighlight);
	}

	hasPrevMarkup(): boolean {
		if (!this.documentData) {
			return false;
		} else if (!this.documentData['searchHitData']) {
			return false;
		} else if (this.documentData['searchHitData'].currentHighlight == undefined) {
			return false;
		} else if ((this.documentData['searchHitData'].currentHighlight - 1) < 0) {
			return false;
		}
		return true;
	}

	hasNextMarkup(): boolean {
		if (!this.documentData) {
			return false;
		} else if (!this.documentData['searchHitData']) {
			return false;
		} else if (this.documentData['searchHitData'].currentHighlight == undefined) {
			return false;
		} else if ((this.documentData['searchHitData'].currentHighlight + 1) >= this.documentData['searchHitData'].highlightsTotal) {
			return false;
		}
		return true;
	}	
}
